{
  "page_count": "من {n, plural, one{# صفحة} other{# من الصفحات}}"
}
